import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Cellulite: genetisch of te behandelen?</title>
                <link rel="canonical" href={route("blogs.thirty-two")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – personal training Uden en Schijndel komt met een nieuwe blog. Deze blog zal veel vrouwen aanspreken dit worstelen met een ‘sinaasappelhuid’. Cellulite is iets waar veel vrouwen mee worstelen en willen hier graag vanaf. In deze blog gaan we hier dieper op in om erachter te komen of deze vorm genetisch is of dat je er iets aan kunt doen om het te laten verdwijnen. Lees je met ons mee?"
                />
                <meta
                    property="og:description"
                    content="WE ARE – personal training Uden en Schijndel komt met een nieuwe blog. Deze blog zal veel vrouwen aanspreken dit worstelen met een ‘sinaasappelhuid’. Cellulite is iets waar veel vrouwen mee worstelen en willen hier graag vanaf. In deze blog gaan we hier dieper op in om erachter te komen of deze vorm genetisch is of dat je er iets aan kunt doen om het te laten verdwijnen. Lees je met ons mee?"
                />
                <meta property="og:url" content={route("blogs.thirty-two")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Cellulite: genetisch of te behandelen? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/cellulite.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/cellulite.webp"
                                    type="image/webp"
                                    alt="Cellulite"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/cellulite.jpg"
                                    type="image/jpeg"
                                    alt="Cellulite"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/cellulite.jpg"
                                    alt="Cellulite"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Cellulite: genetisch of te behandelen?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – personal training Uden en Schijndel komt met
                        een nieuwe blog. Deze blog zal veel vrouwen aanspreken
                        dit worstelen met een ‘sinaasappelhuid’. Cellulite is
                        iets waar veel vrouwen mee worstelen en willen hier
                        graag vanaf. In deze blog gaan we hier dieper op in om
                        erachter te komen of deze vorm{" "}
                        <a
                            href={route("blogs.twenty-eight")}
                            class="text-we-are-yellow"
                        >
                            genetisch
                        </a>{" "}
                        is of dat je er iets aan kunt doen om het te laten
                        verdwijnen. Lees je met ons mee?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is Cellulite?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Gynoïde lipodystrofie is een gevolg van verandering in
                        de structuur van vetcellen. Om het simpel te houden
                        worden de vetcellen groter en worden naar buiten
                        gedrukt. Soms voelt en ziet de huid er bobbelig uit. Dit
                        wordt veroorzaakt door de extra vochtopbouw in het
                        weefsel. De ene persoon ervaart meer cellulite dan de
                        andere persoon.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Normaliter zou een normale ontwikkeling van vetweefsel
                        beginnen in de baarmoeder en stoppen tot een kind
                        ongeveer 18 maanden is. Na een tijdelijke ‘pauze’ wordt
                        dit weer opgepakt vanaf de puberteit. Echter bevinden
                        veel mensen zich in een constante status van vet
                        celgroei en het aanmaken van nieuwe vetcellen omdat er
                        voedsel in overvloed is. Het overeten (meer calorieën
                        eten dan je lichaam nodig heeft) heeft hier een grote
                        invloed op.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat veroorzaakt Cellulite?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoeken tonen nog geen waterdicht antwoordt wanneer
                        het gaat om de oorzaak van Cellulite. Verschillende
                        onderzoeken tonen wel verbanden tussen verschillende
                        factoren en Cellulite zoals de hormonen insuline en
                        oestrogeen (Venereol, 2013) (Menopauzalny, 2014).
                        Hieronder een korte opsomming van de verbanden die
                        verschillende onderzoeken hebben gelegd:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li>
                            Hormonale disbalans door hoge insulinewaarden of
                            bijvoorbeeld tijdens{" "}
                            <a
                                href={route("blogs.eighteenth")}
                                class="text-we-are-yellow"
                            >
                                de menopauze
                            </a>
                            .
                        </li>
                        <li>
                            Cellulite is bijna alleen terug te vinden bij vrouw
                            waardoor oestrogeen een belangrijke rol speelt.
                            Oestrogeen verhoogt de activiteit van de vetcellen
                            in de dijen.
                        </li>
                        <li>
                            Prolactine maakt cellulite beter zichtbaar door een
                            hogere vochtwaarde in het vetweefsel
                        </li>
                    </ol>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Is het aanpassen van leefstijl voldoende?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vaak wordt gedacht dat het aanpassen van je leefstijl
                        met o.a. voeding en beweging cellulite doet laten
                        verdwijnen. Onderzoeken tonen dit niet tot weinig aan.
                        Dat neemt niet weg dat er voorbeelden zijn van mensen
                        die minder cellulite hadden na het verbeteren van hun
                        leefstijl. Echter zijn hier harde bewijzen voor.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe kom je dan wel van Cellulite af?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Iedere vrouw krijgt wel op een of andere manier met
                        Cellulite te maken, voornamelijk in de puberteit of
                        tijdens{" "}
                        <a
                            href={route("blogs.fourteenth")}
                            class="text-we-are-yellow"
                        >
                            een zwangerschap
                        </a>
                        . Hoewel er trainers zijn dit beweren dat ze je er vanaf
                        kunnen helpen is dit niet het geval. Zoals je hebt
                        gelezen bestaat er weinig tot geen literatuur met
                        bewijzen dat je door het aanpassen van je leefstijl er
                        vanaf kan komen. Om de kans zo groot mogelijk te maken
                        raden we aan om vooral actief te blijven,
                        voedingspatronen te volgen met een lage
                        koolhydraatinname en je{" "}
                        <a
                            href={route("blogs.first")}
                            class="text-we-are-yellow"
                        >
                            stress laag te houden
                        </a>
                        .
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Heb je ook al onze blog gelezen over hoe je snel{" "}
                        <a
                            href={route("blogs.thirty-one")}
                            class="text-we-are-yellow"
                        >
                            een platte buik
                        </a>{" "}
                        krijgt?
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Menopauzalny, P. (2014, Oktober 13). Opgehaald van:{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/26327870/"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/26327870/{" "}
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Venereol, J. E. (2013, Maart 27). Opgehaald van:{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/22758934/"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/22758934/{" "}
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
